import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { UseFormSetValue, UseFormGetValues } from 'react-hook-form';
import { IFeedbackFormSource, QuestionResponse } from '../interfaces/index.type';
import { Checkbox } from '@navi/web-ui/lib/primitives';

interface RequiredCheckboxInputProps {
  setValue: UseFormSetValue<any>;
  getValue: UseFormGetValues<any>;
  source: IFeedbackFormSource;
  question: QuestionResponse;
  noDataGivenFlag: boolean;
  setNoDataGivenFlag: Dispatch<SetStateAction<boolean>>;
  cachedValue: { prev: string; current: string };
  setCachedValue: Dispatch<SetStateAction<{ prev: string; current: string }>>;
  className: string;
  title: string;
}

const RequiredCheckboxInput = ({
  setValue,
  getValue,
  source,
  question,
  noDataGivenFlag,
  setNoDataGivenFlag,
  cachedValue,
  setCachedValue,
  className,
  title
}: RequiredCheckboxInputProps) => {
  const { referenceId } = question;

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
    };
  }, []);

  const checkboxOnChangeHandler = () => {
    if (noDataGivenFlag) {
      setValue(`${source}_${referenceId}`, cachedValue.prev);
      setCachedValue({ ...cachedValue, current: cachedValue.prev });
    } else {
      setCachedValue({ prev: getValue(`${source}_${referenceId}`), current: '' });
      setValue(`${source}_${referenceId}`, '');
    }

    setNoDataGivenFlag(!noDataGivenFlag);
  };

  return (
    <div className={className}>
      <Checkbox checked={noDataGivenFlag} onChange={checkboxOnChangeHandler} title={title} />
    </div>
  );
};

export default RequiredCheckboxInput;
